/**
 * QrInvitePoster — printable QR poster. Scanning opens /resident with the
 * community code pre-filled on the registration screen.
 */
import { QRCodeSVG } from 'qrcode.react';
import { Dialog, DialogContent } from './ui/dialog';
import { Printer } from 'lucide-react';

const GOLD = '#C9A962';

export default function QrInvitePoster({ open, onClose, propertyName, code }) {
  if (!code) return null;
  const url = `${window.location.origin}/resident?code=${encodeURIComponent(code)}`;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-sm bg-white text-black p-0 overflow-hidden print:shadow-none" data-testid="qr-invite-poster">
        <div id="qr-poster-print" className="p-8 text-center">
          <p className="text-[10px] uppercase tracking-[0.4em] text-zinc-500">Noble Empire Cleaning Services</p>
          <h2 className="text-2xl font-black uppercase mt-1" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
            Join the <span style={{ color: GOLD }}>NECS Resident</span> App
          </h2>
          <p className="text-xs text-zinc-600 mt-1 mb-5">{propertyName}</p>
          <div className="inline-block p-4 rounded-2xl border-4" style={{ borderColor: GOLD }}>
            <QRCodeSVG value={url} size={200} level="H" fgColor="#1a1a1a" data-testid="qr-invite-svg" />
          </div>
          <p className="text-sm font-bold mt-4">Scan to register — your community code fills in automatically</p>
          <p className="text-lg font-black tracking-[0.3em] mt-2" style={{ color: GOLD }} data-testid="qr-invite-code">{code}</p>
          <p className="text-[10px] text-zinc-500 mt-3">Service alerts · violation reporting · community updates<br />support@nobleempirecs.com</p>
        </div>
        <div className="p-3 border-t bg-zinc-50 flex justify-end print:hidden">
          <button onClick={() => window.print()}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-bold"
            style={{ backgroundColor: '#1a1a1a', color: '#fff' }} data-testid="qr-invite-print-btn">
            <Printer className="h-3.5 w-3.5" /> Print Poster
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
